import React from "react";

// import assets
import RightLeaveSrc from "../assets/images/svg-right-blue.webp";
import LeftLeaveSrc from "../assets/images/svg-left-blue.webp";

const ReviewItem = ({ classname, component }) => {
  return (
    <div className={`review-item ${classname}`}>
      <img src={LeftLeaveSrc} className="leave-img" alt="left" />
      <div className="review-text font-notosans">{component}</div>
      <img src={RightLeaveSrc} className="leave-img" alt="right" />
    </div>
  );
};

export default ReviewItem;
